<template>
  <div class="md-layout">
    <CSLoading :is-loading="isLoading"></CSLoading>
    <div class="md-layout-item md-size-100 product-list">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <span class="material-symbols-outlined">package_2</span>
          </div>
          <h4 class="title">{{ $t("products.products") }}</h4>
          <md-button v-if="hasPermission('Write', 'Products', 'Create')" class="md-icon-button md-success add-button" @click="showCreateModal">
            <md-icon>add</md-icon>
          </md-button>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-25">
              <md-field md-clearable>
                <label>{{ $t("products.keywords") }}</label>
                <md-input v-model="filters.keywords" @input="debounceApplyFilters"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-25">
              <md-field md-clearable>
                <label>{{ $t("products.sku") }}</label>
                <md-input v-model="filters.sku" @input="debounceApplyFilters"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20">
              <md-switch v-model="filters.exactMatchSku" @change="debounceApplyFilters">{{ $t("products.exactMatch") }}</md-switch>
            </div>
            <div class="md-layout md-layout-item md-size-15">
              <md-checkbox v-model="enableBulky">{{ $t("products.bulky") }}</md-checkbox>
              <md-switch v-model="filterBulky" :disabled="!enableBulky" />
            </div>
            <div class="md-layout-item md-size-15">
              <md-switch v-model="filters.includeBWare" @change="debounceApplyFilters" class="md-primary">{{ $t("products.includeBWare") }}</md-switch>
            </div>
          </div>
          <div class="md-layout">
            <div class="md-lay-out-item md-size-25">
              <md-button v-if="hasPermission('Write', 'Products', 'Export')" @click="exportProducts" class="md-success">{{ $t("products.export") }}</md-button>
            </div>
          </div>
          <div class="table-sticky">
            <v-server-table :columns="tableColumns" :options="tableOptions" ref="table" class="table-products" id="table-products">
              <template #h__hs>
                <div class="head-hs">{{ $t("products.hsCode") }}</div>
              </template>
              <template #actions="{ row }">
                <div class="md-table-cell-container cell-actions">
                  <md-menu v-if="hasPermission('Write', 'Products', 'Edit') || hasPermission('Write', 'Products', 'BulkGood')" md-size="big" md-direction="bottom-start">
                    <md-button :disabled="selectedProduct" class="md-icon-button" md-menu-trigger>
                      <md-icon>edit</md-icon>
                    </md-button>
                    <md-menu-content>
                      <md-menu-item v-if="hasPermission('Write', 'Products', 'Edit')" @click="showEditModal(row)">
                        <span>{{ $t("products.editProduct") }}</span>
                      </md-menu-item>

                      <md-menu-item v-if="hasPermission('Write', 'Products', 'BulkGood')" @click="handleCreateBulkGood(row)">
                        <span>{{ $t("products.createBGoods") }}</span>
                      </md-menu-item>
                    </md-menu-content>
                  </md-menu>
                </div>
              </template>
              <template #name="{ row }">
                <div class="cell-name">
                  {{ row.name && row.name.substring(0, 50) }}
                </div>
              </template>
              <template #shippingStats="{ row }">
                <div class="cell-outboundCarrier">
                  <div class="text-nowrap">1d: {{ row.productsShippingLastDay || 0 }} {{ $t("products.shippingStatsPcs") }}</div>
                  <div class="text-nowrap">7d: {{ row.productsShipping7Days || 0 }} {{ $t("products.shippingStatsPcs") }}</div>
                  <div class="text-nowrap">30d: {{ row.productsShipping30Days || 0 }} {{ $t("products.shippingStatsPcs") }}</div>
                  <div class="text-nowrap">90d: {{ row.productsShipping90Days || 0 }} {{ $t("products.shippingStatsPcs") }}</div>
                  <div class="text-nowrap">365d: {{ row.productsShipping365Days || 0 }} {{ $t("products.shippingStatsPcs") }}</div>
                </div>
              </template>
              <template #shippingSize="{ row }">
                <div class="cell-outboundCarrier">
                  <div class="text-nowrap">{{ $t("products.table.shippingSizeLength") }}: {{ row.shippingSizeLength | formatNumberGerman(2) }} cm</div>
                  <div class="text-nowrap">{{ $t("products.table.shippingSizeWidth") }}: {{ row.shippingSizeWidth | formatNumberGerman(2) }} cm</div>
                  <div class="text-nowrap">{{ $t("products.table.shippingSizeHeight") }}: {{ row.shippingSizeHeight | formatNumberGerman(2) }} cm</div>
                  <div class="text-nowrap">{{ $t("products.table.shippingSizeWeight") }}: {{ row.shippingSizeWeight | formatNumberGerman(2) }} kg</div>
                </div>
              </template>
              <!-- <template #shippingSizeLength="{ row }">
                <div class="cell-shipping-size-length">{{ row.shippingSizeLength | formatNumberGerman(0) }} cm</div>
              </template>
              <template #shippingSizeWidth="{ row }">
                <div class="cell-shipping-size-width">{{ row.shippingSizeWidth | formatNumberGerman }} cm</div>
              </template>
              <template #shippingSizeHeight="{ row }">
                <div class="cell-shipping-size-height">{{ row.shippingSizeHeight | formatNumberGerman }} cm</div>
              </template>
              <template #shippingSizeWeight="{ row }">
                <div class="cell-shipping-size-weight">{{ row.shippingSizeWeight | formatNumberGerman }} kg</div>
              </template> -->
              <template #hs="{ row }">
                <div class="cell-hs" v-if="row.condition === 'B-Ware'">&ndash;</div>
                <div class="cell-hs" v-else>
                  <div class="text-nowrap">UK: {{ row.hsUK || 0 }}</div>
                  <div class="text-nowrap">EU: {{ row.hsEU || 0 }}</div>
                  <div class="text-nowrap">CH: {{ row.hsCH || 0 }}</div>
                  <div class="text-nowrap">{{ $t("products.customsTariff") }}: {{ (row.customsTariff || 0) | formatUnit("%", 1, 1) }}</div>
                </div>
              </template>
              <template #bulky="{ row }">
                <span v-if="row.bulky === 'true'" class="text-success material-symbols-outlined">done</span>
                <span v-else-if="row.bulky === 'false'" class="text-danger material-symbols-outlined">close</span>
              </template>
              <template #outboundCarrier="{ row }">
                <div class="cell-outboundCarrier">
                  <div class="text-nowrap">DE: {{ row.outboundCarrier || "--" }}</div>
                  <div class="text-nowrap">UK: {{ row.carrierUK || "--" }}</div>
                  <div class="text-nowrap">EU: {{ row.carrierEU || "--" }}</div>
                </div>
              </template>
              <template #supplier="{ row }">
                <div class="cell-supplier">
                  {{ row.supplier && row.supplier.name }}
                </div>
              </template>
              <template #masterboxDementions="{ row }">
                <div class="cell-outboundCarrier">
                  <div class="text-nowrap">{{ $t("products.table.skuMasterbox") }}: {{ row.skuMasterbox }}</div>
                  <div class="text-nowrap">{{ $t("products.table.mbSkuAmount") }}: {{ row.mbSkuAmount | formatUnit("pcs") }}</div>
                  <div class="text-nowrap">{{ $t("products.table.mbSkuLength") }}: {{ row.mbSkuLength | formatUnit("cm") }}</div>
                  <div class="text-nowrap">{{ $t("products.table.mbSkuWidth") }}: {{ row.mbSkuWidth | formatUnit("cm") }}</div>
                  <div class="text-nowrap">{{ $t("products.table.mbSkuHeight") }}: {{ row.mbSkuHeight | formatUnit("cm") }}</div>
                  <div class="text-nowrap">{{ $t("products.table.mbSkuWeight") }}: {{ row.mbSkuWeight | formatUnit("kg") }}</div>
                </div>
              </template>
              <template #cabQuantity="{ row }">
                <div class="cell-outboundCarrier">
                  <div class="text-nowrap">{{ row.cabQuantity | formatUnit("pcs") }}</div>
                </div>
              </template>
              <template #shippingWeights="{ row }">
                <div class="cell-outboundCarrier">
                  <div class="text-nowrap">{{ $t("products.table.skuPaperWeight") }}: {{ row.skuPaperWeight | formatUnit("gr") }}</div>
                  <div class="text-nowrap">{{ $t("products.table.skuPlasticWeight") }}: {{ row.skuPlasticWeight | formatUnit("gr") }}</div>
                  <div class="text-nowrap">{{ $t("products.table.skuWoodWeight") }}: {{ row.skuWoodWeight | formatUnit("gr") }}</div>
                  <div class="text-nowrap">{{ $t("products.table.skuMetalWeight") }}: {{ row.skuMetalWeight | formatUnit("gr") }}</div>
                </div>
              </template>
              <template #inFlow="{ row }">{{ row.inFlow || "-" }}</template>
            </v-server-table>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <CreateProductModal v-if="createModal" @close="hideCreateModal" @saved="onProductCreated" />

    <modal v-if="editModal" @close="hideEditModal" class-name="shipping-plan-modal-container">
      <template slot="header">
        <h4 class="modal-title">Edit Product</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="hideEditModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <ValidationObserver v-slot="{}" ref="editForm">
          <md-tabs>
            <md-tab id="ProductGeneral" :md-label="$t('products.ProductGeneral')">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-50">
                  <ValidationProvider name="sku" rules="required" v-slot="{ passed, failed, errors }">
                    <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                      <label>{{ $t("products.sku") }}</label>
                      <md-input v-model="sku" type="text" :disabled="!hasPermission('Write', 'Products', 'Sku')"> </md-input>
                      <div class="md-error" v-if="errors[0]">
                        {{ $t(errors[0]) }}
                      </div>
                    </md-field>
                  </ValidationProvider>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-field>
                    <label>{{ $t("products.condition") }}</label>
                    <md-select v-model="condition" name="condition" id="condition">
                      <md-option value="Neu">{{ $t("products.conditionNew") }}</md-option>
                      <md-option value="B-Ware">{{ $t("products.conditionBWare") }}</md-option>
                    </md-select>
                  </md-field>
                </div>
              </div>
              <ValidationProvider name="name" rules="required" v-slot="{ passed, failed, errors }">
                <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                  <label>{{ $t("products.name") }}</label>
                  <md-input v-model="name" type="text" :disabled="!hasPermission('Write', 'Products', 'Name')"> </md-input>
                  <div class="md-error" v-if="errors[0]">
                    {{ $t(errors[0]) }}
                  </div>
                </md-field>
              </ValidationProvider>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-50">
                  <md-field>
                    <label>{{ $t("products.shippingSizeLength") }}</label>
                    <md-input v-model="shippingSizeLength" type="number"> </md-input>
                    <span class="md-suffix">cm</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-field>
                    <label>{{ $t("products.shippingSizeWidth") }}</label>
                    <md-input v-model="shippingSizeWidth" type="number"> </md-input>
                    <span class="md-suffix">cm</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-field>
                    <label>{{ $t("products.shippingSizeHeight") }}</label>
                    <md-input v-model="shippingSizeHeight" type="number"> </md-input>
                    <span class="md-suffix">cm</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-50">
                  <md-field>
                    <label>{{ $t("products.shippingSizeWeight") }}</label>
                    <md-input v-model="shippingSizeWeight" type="number"> </md-input>
                    <span class="md-suffix">kg</span>
                  </md-field>
                </div>
              </div>

              <div style="width: 30%">
                <md-switch v-model="bulky" value="true" class="md-primary">{{ $t("products.bulky") }}</md-switch>
              </div>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-50">
                  <ValidationProvider name="hsUK" rules="digits:8" v-slot="{ passed, failed, errors }">
                    <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                      <label>{{ $t("products.hsUK") }}</label>
                      <md-input v-model="hsUK" type="number" :disabled="isBWare"> </md-input>
                      <div class="md-error" v-if="errors[0]">
                        {{ $t(errors[0]) }}
                      </div>
                    </md-field>
                  </ValidationProvider>
                  <ValidationProvider name="hsEU" rules="digits:10" v-slot="{ passed, failed, errors }">
                    <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                      <label>{{ $t("products.hsEU") }}</label>
                      <md-input v-model="hsEU" type="number" :disabled="isBWare"> </md-input>
                      <div class="md-error" v-if="errors[0]">
                        {{ $t(errors[0]) }}
                      </div>
                    </md-field>
                  </ValidationProvider>
                  <ValidationProvider name="hsCH" rules="integer" v-slot="{ passed, failed, errors }">
                    <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                      <label>{{ $t("products.hsCH") }}</label>
                      <md-input v-model="hsCH" type="number" :disabled="isBWare"> </md-input>
                      <div class="md-error" v-if="errors[0]">
                        {{ $t(errors[0]) }}
                      </div>
                    </md-field>
                  </ValidationProvider>
                  <ValidationProvider name="customsTariff" :rules="{ min_value: 0.0, decimal: 1 }" v-slot="{ passed, failed, errors }">
                    <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                      <label>{{ $t("products.customsTariff") }}</label>
                      <md-input v-model="customsTariff" type="number" min="0.0" step="0.1" inputmode="decimal" :disabled="isBWare"> </md-input>
                      <span class="md-suffix">%</span>
                      <div class="md-error" v-if="errors[0]">
                        {{ $t(errors[0]) }}
                      </div>
                    </md-field>
                  </ValidationProvider>
                </div>
                <div class="md-layout-item md-size-50">
                  <ValidationProvider name="outboundCarrier" rules="required" v-slot="{ errors }">
                    <div class="wrap-v-select custom-wrap-v-select" style="text-align: left; margin-bottom: 15px">
                      <label v-if="!!outboundCarrierName">{{ $t("products.outboundCarrier") }}</label>
                      <SelectCarrier v-model="outboundCarrierName" :allowedCarriers="allowedCarriers" :placeholder="$t('products.outboundCarrier')" :multiple="false" :customClass="'custom-select'" />
                      <div class="md-error" v-if="errors[0]">{{ $t(errors[0]) }}</div>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider name="carrierUK" rules="required" v-slot="{ errors }">
                    <div class="wrap-v-select custom-wrap-v-select" style="text-align: left; margin-bottom: 15px">
                      <label v-if="!!carrierUKName">{{ $t("products.carrierUK") }}</label>
                      <SelectCarrier v-model="carrierUKName" :allowedCarriers="allowedCarriers" :placeholder="$t('products.carrierUK')" :multiple="false" :customClass="'custom-select'" />
                      <div class="md-error" v-if="errors[0]">{{ $t(errors[0]) }}</div>
                    </div>
                  </ValidationProvider>
                  <ValidationProvider name="carrierEU" rules="required" v-slot="{ errors }">
                    <div class="wrap-v-select custom-wrap-v-select" style="text-align: left; margin-bottom: 15px">
                      <label v-if="!!carrierEUName">{{ $t("products.carrierEU") }}</label>
                      <SelectCarrier v-model="carrierEUName" :allowedCarriers="allowedCarriers" :placeholder="$t('products.carrierEU')" :multiple="false" :customClass="'custom-select'" />
                      <div class="md-error" v-if="errors[0]">{{ $t(errors[0]) }}</div>
                    </div>
                  </ValidationProvider>
                </div>
              </div>

              <ValidationProvider name="supplierId" rules="required" v-slot="{ errors }">
                <div class="wrap-v-select" style="text-align: left; margin-top: 15px">
                  <v-select label="name" append-to-body v-model="supplierId" :options="supplierNameOptions" :placeholder="$t('products.supplier')"> </v-select>
                  <div class="md-error" v-if="errors[0]">
                    {{ $t(errors[0]) }}
                  </div>
                </div>
              </ValidationProvider>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-50">
                  <ValidationProvider name="moq" rules="integer|min_value:0" v-slot="{ passed, failed, errors }">
                    <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                      <label>{{ $t("products.moq") }}</label>
                      <md-input v-model="moq" type="number" min="0" step="1"> </md-input>
                      <div class="md-error" v-if="errors[0]">
                        {{ $t(errors[0]) }}
                      </div>
                    </md-field>
                  </ValidationProvider>
                </div>
                <div class="md-layout-item md-size-50" style="text-align: left">
                  <md-switch v-model="eol" class="md-primary">{{ $t("products.eol") }}</md-switch>
                </div>
              </div>
            </md-tab>
            <md-tab id="ProductDetails" :md-label="$t('products.ProductDetails')">
              <ValidationProvider name="cabQuantity" rules="integer|min_value:0" v-slot="{ passed, failed, errors }">
                <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                  <label>{{ $t("products.cabQuantity") }}</label>
                  <md-input v-model="cabQuantity" type="number"> </md-input>

                  <span class="md-suffix">pcs</span>
                  <div class="md-error" v-if="errors[0]">
                    {{ $t(errors[0]) }}
                  </div>
                </md-field>
              </ValidationProvider>

              <md-subheader>{{ $t("products.masterboxDementions") }}</md-subheader>
              <div class="md-layout md-gutter mb-3">
                <div class="md-layout-item md-size-50 mb-3">
                  <ValidationProvider name="skuMasterbox" :rules="{ regex: /^[a-zA-Z0-9_-]+$/ }" v-slot="{ passed, failed, errors }">
                    <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                      <label>{{ $t("products.skuMasterbox") }}</label>
                      <md-input v-model="skuMasterbox" type="text"> </md-input>
                      <div class="md-error" v-if="errors[0]">
                        {{ $t(errors[0]) }}
                      </div>
                    </md-field>
                  </ValidationProvider>
                </div>
                <div class="md-layout-item md-size-50 mb-3">
                  <ValidationProvider name="mbSkuAmount" rules="min_value:0|integer" v-slot="{ passed, failed, errors }">
                    <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                      <label>{{ $t("products.mbSkuAmount") }}</label>
                      <md-input v-model="mbSkuAmount" type="number" min="0"> </md-input>
                      <span class="md-suffix">pcs</span>
                      <div class="md-error" v-if="errors[0]">
                        {{ $t(errors[0]) }}
                      </div>
                    </md-field>
                  </ValidationProvider>
                </div>
                <div class="md-layout-item md-size-50 mb-3">
                  <ValidationProvider name="mbSkuLength" :rules="{ min_value: 0.0, decimal: 1 }" v-slot="{ passed, failed, errors }">
                    <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                      <label>{{ $t("products.mbSkuLength") }}</label>
                      <md-input v-model="mbSkuLength" type="number" min="0.1" step="0.1" inputmode="decimal"> </md-input>
                      <span class="md-suffix">cm</span>
                      <div class="md-error" v-if="errors[0]">
                        {{ $t(errors[0]) }}
                      </div>
                    </md-field>
                  </ValidationProvider>
                </div>
                <div class="md-layout-item md-size-50 mb-3">
                  <ValidationProvider name="mbSkuWidth" :rules="{ min_value: 0.0, decimal: 1 }" v-slot="{ passed, failed, errors }">
                    <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                      <label>{{ $t("products.mbSkuWidth") }}</label>
                      <md-input v-model="mbSkuWidth" type="number" min="0.1" step="0.1" inputmode="decimal"> </md-input>
                      <span class="md-suffix">cm</span>
                      <div class="md-error" v-if="errors[0]">
                        {{ $t(errors[0]) }}
                      </div>
                    </md-field>
                  </ValidationProvider>
                </div>
                <div class="md-layout-item md-size-50 mb-3">
                  <ValidationProvider name="mbSkuHeight" :rules="{ min_value: 0.0, decimal: 1 }" v-slot="{ passed, failed, errors }">
                    <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                      <label>{{ $t("products.mbSkuHeight") }}</label>
                      <md-input v-model="mbSkuHeight" type="number" min="0.1" step="0.1" inputmode="decimal"> </md-input>
                      <span class="md-suffix">cm</span>
                      <div class="md-error" v-if="errors[0]">
                        {{ $t(errors[0]) }}
                      </div>
                    </md-field>
                  </ValidationProvider>
                </div>
                <div class="md-layout-item md-size-50 mb-3">
                  <ValidationProvider name="mbSkuWeight" :rules="{ min_value: 0.0, decimal: 2 }" v-slot="{ passed, failed, errors }">
                    <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                      <label>{{ $t("products.mbSkuWeight") }}</label>
                      <md-input v-model="mbSkuWeight" type="number" min="0.1" step="0.1" inputmode="decimal"> </md-input>
                      <span class="md-suffix">kg</span>
                      <div class="md-error" v-if="errors[0]">
                        {{ $t(errors[0]) }}
                      </div>
                    </md-field>
                  </ValidationProvider>
                </div>
              </div>
              <md-divider></md-divider>
              <md-subheader>{{ $t("products.shippingWeights") }}</md-subheader>
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-size-50 mb-3">
                  <ValidationProvider name="skuPaperWeight" :rules="{ min_value: 0.0, decimal: 1 }" v-slot="{ passed, failed, errors }">
                    <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                      <label>{{ $t("products.skuPaperWeight") }}</label>
                      <md-input v-model="skuPaperWeight" type="number" min="0.1" step="0.1" inputmode="decimal"> </md-input>
                      <span class="md-suffix">gr</span>
                      <div class="md-error" v-if="errors[0]">
                        {{ $t(errors[0]) }}
                      </div>
                    </md-field>
                  </ValidationProvider>
                </div>
                <div class="md-layout-item md-size-50 mb-3">
                  <ValidationProvider name="skuPlasticWeight" :rules="{ min_value: 0.0, decimal: 1 }" v-slot="{ passed, failed, errors }">
                    <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                      <label>{{ $t("products.skuPlasticWeight") }}</label>
                      <md-input v-model="skuPlasticWeight" type="number" min="0.1" step="0.1" inputmode="decimal"> </md-input>
                      <span class="md-suffix">gr</span>
                      <div class="md-error" v-if="errors[0]">
                        {{ $t(errors[0]) }}
                      </div>
                    </md-field>
                  </ValidationProvider>
                </div>
                <div class="md-layout-item md-size-50 mb-3">
                  <ValidationProvider name="skuWoodWeight" :rules="{ min_value: 0.0, decimal: 1 }" v-slot="{ passed, failed, errors }">
                    <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                      <label>{{ $t("products.skuWoodWeight") }}</label>
                      <md-input v-model="skuWoodWeight" type="number" min="0.1" step="0.1" inputmode="decimal"> </md-input>
                      <span class="md-suffix">gr</span>
                      <div class="md-error" v-if="errors[0]">
                        {{ $t(errors[0]) }}
                      </div>
                    </md-field>
                  </ValidationProvider>
                </div>
                <div class="md-layout-item md-size-50 mb-3">
                  <ValidationProvider name="skuMetalWeight" :rules="{ min_value: 0.0, decimal: 1 }" v-slot="{ passed, failed, errors }">
                    <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                      <label>{{ $t("products.skuMetalWeight") }}</label>
                      <md-input v-model="skuMetalWeight" type="number" min="0.1" step="0.1" inputmode="decimal"> </md-input>
                      <span class="md-suffix">gr</span>
                      <div class="md-error" v-if="errors[0]">
                        {{ $t(errors[0]) }}
                      </div>
                    </md-field>
                  </ValidationProvider>
                </div>
              </div>
            </md-tab>
          </md-tabs>
        </ValidationObserver>
      </template>

      <template slot="footer">
        <md-button class="md-secondary mr-1" @click="hideEditModal">{{ $t("products.close") }}</md-button>
        <md-button class="md-success" @click="editProduct">{{ $t("products.save") }}</md-button>
      </template>
    </modal>

    <md-dialog :md-active.sync="showConfirmDialog" :md-click-outside-to-close="false">
      <md-dialog-title> {{ $t("products.messages.confirmCreateBGood") }} </md-dialog-title>
      <md-dialog-content>{{ $t("products.messages.confirmCreateBGoodMessage") }} </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-secondary" @click="hideConfirmBGoodModal">{{ $t("products.cancel") }}</md-button>
        <md-button class="md-success" @click="handleCreateBGood">{{ $t("products.confirm") }}</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import { debounce } from "lodash";
import { Modal } from "@/components";
import axiosFactory from "../../services/axios.factory";
import CSLoading from "../../components/Loading/CSLoading.vue";
import { EventBus } from "@/helpers/event-bus";
import { hasPermission } from "../../mixins/auth";
import CreateProductModal from "./CreateProductModal.vue";
import SelectCarrier from "../../components/SelectCarrier/SelectCarrier.vue";

export default {
  components: {
    Modal,
    CSLoading,
    CreateProductModal,
    SelectCarrier,
  },
  data() {
    return {
      isLoading: true,
      createModal: false,
      editModal: false,
      sku: null,
      name: null,
      inStock: null,
      inFlow: null,
      shippingSizeLength: null,
      shippingSizeWidth: null,
      shippingSizeHeight: null,
      shippingSizeWeight: null,
      condition: null,
      hsUK: null,
      hsEU: null,
      hsCH: null,
      customsTariff: null,
      outboundCarrier: null,
      carrierUK: null,
      carrierEU: null,
      bulky: "",
      supplierId: null,
      moq: null,
      eol: false,
      id: null,
      cabQuantity: null,
      mbSkuAmount: null,
      mbSkuHeight: null,
      mbSkuLength: null,
      mbSkuWeight: null,
      mbSkuWidth: null,
      skuMasterbox: null,
      skuMetalWeight: null,
      skuPaperWeight: null,
      skuPlasticWeight: null,
      skuWoodWeight: null,
      enableBulky: false,
      filterBulky: false,
      filters: {
        keywords: "",
        sku: "",
        exactMatchSku: false,
        bulky: "all",
        includeBWare: false,
      },
      tableColumns: [
        "actions",
        "sku",
        "name",
        "inStock",
        "inFlow",
        "shippingStats",
        "shippingSize",
        // "shippingSizeLength",
        // "shippingSizeWidth",
        // "shippingSizeHeight",
        // "shippingSizeWeight",
        "bulky",
        "hs",
        "outboundCarrier",
        //"carrierUK",
        //"carrierEU",
        "supplier",
        "masterboxDementions",
        "cabQuantity",
        "shippingWeights",
      ],
      tableOptions: {
        headings: {
          actions: () => this.$t("products.table.actions"),
          sku: () => this.$t("products.table.sku"),
          name: () => this.$t("products.table.name"),
          inStock: () => this.$t("products.table.inStock"),
          inFlow: () => this.$t("products.table.inFlow"),
          shippingSize: () => this.$t("products.table.shippingSize"),
          shippingSizeLength: () => this.$t("products.table.shippingSizeLength"),
          shippingSizeWidth: () => this.$t("products.table.shippingSizeWidth"),
          shippingSizeHeight: () => this.$t("products.table.shippingSizeHeight"),
          shippingSizeWeight: () => this.$t("products.table.shippingSizeWeight"),
          outboundCarrier: () => this.$t("products.table.outboundCarrier"),
          carrierUK: () => this.$t("products.table.carrierUK"),
          carrierEU: () => this.$t("products.table.carrierEU"),
          bulky: () => this.$t("products.table.bulky"),
          supplier: () => this.$t("products.table.supplier"),
          masterboxDementions: () => this.$t("products.masterboxDementions"),
          cabQuantity: () => this.$t("products.cabQuantity"),
          shippingWeights: () => this.$t("products.shippingWeights"),
          shippingStats: () => this.$t("products.shippingStats"),
        },
        perPage: 25,
        perPageValues: [25, 100, 5000],
        filterable: false,
        sortIcon: {
          is: "fa-sort",
          base: "fa",
          up: "fa-sort-up",
          down: "fa-sort-down",
        },
        sortable: ["sku", "name", "shippingSizeLength", "shippingSizeWidth", "shippingSizeHeight", "shippingSizeWeight", "outboundCarrier"],
        params: {},
        resizableColumns: false,
        requestFunction: this.requestFunction,
        responseAdapter: this.responseFunction,
        rowClassCallback: this.rowClassCallback,
        pagination: {
          show: true,
        },
        texts: {
          count: this.$t("table.count"),
          limit: this.$t("table.records"),
          noResults: this.$t("table.noRecord"),
        },
        columnsClasses: {
          masterboxDementions: "text-left",
          cabQuantity: "text-left",
          shippingWeights: "text-left",
          shippingStats: "text-left shipping-stats-header",
          shippingSize: "text-left",
          name: "text-left",
          supplier: "text-left",
        },
      },
      tableData: [],
      totalItems: 0,
      table: null,
      showConfirmDialog: false,
      selectedProduct: null,
    };
  },
  computed: {
    isBWare() {
      return this.condition === "B-Ware";
    },
    supplierNameOptions() {
      return this.$store.state.shippingData.supplierNames.map((s) => ({ value: s.id, name: s.name })) || [];
    },
    carrierOptions() {
      return (this.$store.state.shippingData.carriers || []).filter((c) => this.allowedCarriers.includes(c.name));
    },
    allowedCarriers() {
      return ["DHL", "DPD", "Spedition"];
    },
    outboundCarrierName: {
      get() {
        const c = (this.$store.state.shippingData.carriers || []).find((x) => x.id === this.outboundCarrier);
        return c ? c.name : null;
      },
      set(name) {
        const c = (this.$store.state.shippingData.carriers || []).find((x) => x.name === name);
        this.outboundCarrier = c ? c.id : null;
      },
    },
    carrierUKName: {
      get() {
        const c = (this.$store.state.shippingData.carriers || []).find((x) => x.id === this.carrierUK);
        return c ? c.name : null;
      },
      set(name) {
        const c = (this.$store.state.shippingData.carriers || []).find((x) => x.name === name);
        this.carrierUK = c ? c.id : null;
      },
    },
    carrierEUName: {
      get() {
        const c = (this.$store.state.shippingData.carriers || []).find((x) => x.id === this.carrierEU);
        return c ? c.name : null;
      },
      set(name) {
        const c = (this.$store.state.shippingData.carriers || []).find((x) => x.name === name);
        this.carrierEU = c ? c.id : null;
      },
    },
  },
  watch: {
    enableBulky(bool) {
      if (!bool) {
        this.filters.bulky = "all";
      } else {
        if (this.filterBulky) {
          this.filters.bulky = "true";
        } else {
          this.filters.bulky = "false";
        }
      }

      this.debounceApplyFilters();
    },
    filterBulky(bool) {
      if (bool) {
        this.filters.bulky = "true";
      } else {
        this.filters.bulky = "false";
      }

      this.debounceApplyFilters();
    },
  },
  methods: {
    hideCreateModal() {
      this.createModal = false;
    },
    onProductCreated() {
      this.applyFilters({});
      this.hideCreateModal();
    },
    hideEditModal() {
      this.editModal = false;
      this.resetForm();
    },
    resetForm() {
      this.condition = null;
      this.hsUK = null;
      this.hsEU = null;
      this.hsCH = null;
      this.customsTariff = null;
      this.supplierId = null;
      this.moq = null;
      this.eol = false;

      this.cabQuantity = null;
      this.mbSkuAmount = null;
      this.mbSkuHeight = null;
      this.mbSkuLength = null;
      this.mbSkuWeight = null;
      this.mbSkuWidth = null;
      this.skuMasterbox = null;
      this.skuMetalWeight = null;
      this.skuPaperWeight = null;
      this.skuPlasticWeight = null;
      this.skuWoodWeight = null;

      // this.sku = null;
      // this.name = null;
      // this.shippingSizeLength = null;
      // this.shippingSizeWidth = null;
      // this.shippingSizeHeight = null;
      // this.shippingSizeWeight = null;
      // this.outboundCarrier = null;
      // this.carrierUK = null;
      // this.carrierEU = null;
      // this.bulky = "";
    },
    showCreateModal(product = {}) {
      this.sku = product.sku;
      this.name = product.name;
      this.shippingSizeLength = product.shippingSizeLength;
      this.shippingSizeWidth = product.shippingSizeWidth;
      this.shippingSizeHeight = product.shippingSizeHeight;
      this.shippingSizeWeight = product.shippingSizeWeight;
      this.outboundCarrier = product.outboundCarrier;
      this.carrierUK = product.carrierUK;
      this.carrierEU = product.carrierEU;
      this.bulky = "";
      this.createModal = true;
    },
    showEditModal(product) {
      this.sku = product.sku;
      this.name = product.name;
      this.inStock = product.inStock;
      this.inFlow = product.inFlow;
      this.shippingSizeLength = product.shippingSizeLength;
      this.shippingSizeWidth = product.shippingSizeWidth;
      this.shippingSizeHeight = product.shippingSizeHeight;
      this.shippingSizeWeight = product.shippingSizeWeight;
      this.condition = product.condition;
      this.hsUK = product.hsUK;
      this.hsEU = product.hsEU;
      this.hsCH = product.hsCH;
      this.customsTariff = product.customsTariff;

      this.cabQuantity = product.cabQuantity;
      this.mbSkuAmount = product.mbSkuAmount;
      this.mbSkuHeight = product.mbSkuHeight;
      this.mbSkuLength = product.mbSkuLength;
      this.mbSkuWeight = product.mbSkuWeight;
      this.mbSkuWidth = product.mbSkuWidth;
      this.skuMasterbox = product.skuMasterbox;
      this.skuMetalWeight = product.skuMetalWeight;
      this.skuPaperWeight = product.skuPaperWeight;
      this.skuPlasticWeight = product.skuPlasticWeight;
      this.skuWoodWeight = product.skuWoodWeight;

      let carrier = this.carrierOptions.find((i) => i.name == product.outboundCarrier);
      this.outboundCarrier = carrier && carrier.id;
      carrier = this.carrierOptions.find((i) => i.name == product.carrierUK);
      this.carrierUK = carrier && carrier.id;
      carrier = this.carrierOptions.find((i) => i.name == product.carrierEU);
      this.carrierEU = carrier && carrier.id;
      var supplier = this.supplierNameOptions.find((i) => i.value == product.supplierId);
      this.supplierId = supplier;
      this.moq = product.moq;
      this.eol = !!product.eol;
      this.bulky = product.bulky;
      this.id = product.id;
      this.editModal = true;
    },

    hideConfirmBGoodModal() {
      this.showConfirmDialog = false;
      this.selectedProduct = null;
    },
    async handleCreateBGood() {
      this.showConfirmDialog = false;
      // create product b good
      this.isLoading = true;
      const supplier = this.supplierNameOptions.find((i) => i.name.includes("B-WARE"));
      console.log("supplier", supplier, this.supplierNameOptions);
      const payload = {
        ...this.selectedProduct,
        sku: this.selectedProduct.sku + "_bware",
        name: "B-Ware - " + this.selectedProduct.name,
        supplierId: supplier?.value,
        condition: "B-Ware",
        hsUK: null,
        hsEU: null,
        hsCH: null,
        customsTariff: null,
      };
      delete payload.id;
      delete payload.supplier;
      console.log("create product b-good", payload);
      this.$store
        .dispatch("shippingData/createProduct", payload)
        .then(() => {
          this.$notify({
            timeout: 2500,
            message: this.$t("products.messages.createdBGoodProduct", { productName: payload.name }),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });

          this.applyFilters({});
        })
        .catch(() => {
          this.$notify({
            timeout: 2500,
            message: this.$t("products.messages.canNotCreateBGoodProduct"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "error",
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.selectedProduct = null;
        });
    },

    /**
     * 
     * A.) Check whether a B-goods item has been selected. If the SKU you select ends with "_bware", a message should appear: "No B-goods product can be created for B-goods products." (IF "SKU" ends with "_bware" THEN TXTBOX ELSE next.

B.) Check whether the product already exists. Example: For product "BBQ11" I would like to create a "B-goods product", then it should be checked whether "BBQ11_bware" already exists. If yes, then the message: "The SKU BBQ11_bware already exists. Nothing has been created. Otherwise continue.

C.) Lightbox with renewed query: "Do you really want to create a "B-goods product" for this product?" with 2 buttons: "Cancel" and "Confirm". If you click on "Cancel", the lightbox should be closed and nothing should happen. Click on "Confirm" to continue.

D.) Now a new product is to be created with the following content:

SKU: As selected + "_bware" (So SOMO3A was selected, the new product then gets SOMO3A_bware as SKU)

Name: As selected + BEFORE "B-Ware - " (Take a look at the current ones, you can see it there)

Parcel length, width, height, weight, bulky goods, all HS codes: As selected

Supplier: CHANGE to "B-goods (placeholder)"

*Are there any other fields to check?

E.) Message: The product "NAMING THE NEW SKU HERE" has been created.
     * @param product 
     */
    async handleCreateBulkGood(product) {
      // this.$router.push({ name: "BulkGoods", params: { sku: product.sku } });
      // cas A
      if (product.sku.endsWith("_bware")) {
        this.$notify({
          timeout: 2500,
          message: this.$t("products.messages.bwareProductCanNotCreateBGood"),
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "error",
        });
        return;
      }
      this.isLoading = true;
      // case B
      let sku = product.sku + "_bware";
      let productExist = await this.findProduct(sku);
      console.log("productExist", productExist);
      if (productExist) {
        this.$notify({
          timeout: 2500,
          message: this.$t("products.messages.productExistBGood", { sku }),
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "error",
        });
        this.isLoading = false;
        return;
      }
      // case C
      else {
        this.showConfirmDialog = true;
        this.selectedProduct = product;
      }
    },
    async findProduct(sku) {
      // try find in current list
      let found = this.tableData.find((i) => i.sku === sku);
      if (found) {
        return found;
      }

      found = await axiosFactory()
        .get(`/shipping_data/products`, { params: { keywords: sku, bulky: "all", pageIndex: 0, pageSize: 25, includeBWare: true } })
        .catch(function (e) {})
        .then((res) => {
          return res.data.data.length > 0 ? res.data.data[0] : null;
        })
        .finally(() => {
          this.isLoading = false;
        });

      return found;
    },
    createProduct() {
      this.$refs.createForm.validate().then((success) => {
        if (!success) {
          this.$notify({
            timeout: 2500,
            message: this.$t("products.messages.checkFields"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          return;
        }

        this.isLoading = true;
        let carrier = this.carrierOptions.find((i) => i.id === this.outboundCarrier);
        let carrierUK = this.carrierOptions.find((i) => i.id === this.carrierUK);
        let carrierEU = this.carrierOptions.find((i) => i.id === this.carrierEU);
        const payload = {
          sku: this.sku,
          name: this.name,
          shippingSizeLength: this.shippingSizeLength ? parseFloat(this.shippingSizeLength) : 0,
          shippingSizeWidth: this.shippingSizeWidth ? parseFloat(this.shippingSizeWidth) : 0,
          shippingSizeHeight: this.shippingSizeHeight ? parseFloat(this.shippingSizeHeight) : 0,
          shippingSizeWeight: this.shippingSizeWeight ? parseFloat(this.shippingSizeWeight) : 0,
          condition: this.condition || null,
          hsUK: this.hsUK,
          hsEU: this.hsEU,
          hsCH: this.hsCH,
          customsTariff: this.customsTariff === "" || this.customsTariff === null || this.customsTariff === undefined ? null : parseFloat(this.customsTariff),
          outboundCarrier: carrier && carrier.name,
          carrierUK: carrierUK && carrierUK.name,
          carrierEU: carrierEU && carrierEU.name,
          bulky: this.bulky ? this.bulky : "false",
          supplierId: this.supplierId.value,
          cabQuantity: this.cabQuantity,
          mbSkuAmount: this.mbSkuAmount,
          mbSkuHeight: this.mbSkuHeight,
          mbSkuLength: this.mbSkuLength,
          mbSkuWeight: this.mbSkuWeight,
          mbSkuWidth: this.mbSkuWidth,
          skuMasterbox: this.skuMasterbox,
          skuMetalWeight: this.skuMetalWeight,
          skuPaperWeight: this.skuPaperWeight,
          skuPlasticWeight: this.skuPlasticWeight,
          skuWoodWeight: this.skuWoodWeight,
        };
        // console.log("create product", payload);
        this.$store
          .dispatch("shippingData/createProduct", payload)
          .then(() => {
            this.$notify({
              timeout: 2500,
              message: this.$t("products.messages.created"),
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            this.applyFilters({});
          })
          .then(() => {
            this.hideCreateModal();
          })
          .catch(() => {
            this.$notify({
              timeout: 2500,
              message: this.$t("products.messages.productSkuDuplicated"),
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "error",
            });
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    editProduct() {
      this.$refs.editForm.validate().then((success) => {
        if (!success) {
          this.$notify({
            timeout: 2500,
            message: this.$t("products.messages.checkFields"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          return;
        }

        this.isLoading = true;
        let carrier = this.carrierOptions.find((i) => i.id === this.outboundCarrier);
        let carrierUK = this.carrierOptions.find((i) => i.id === this.carrierUK);
        let carrierEU = this.carrierOptions.find((i) => i.id === this.carrierEU);
        const payload = {
          sku: this.sku,
          name: this.name,
          shippingSizeLength: this.shippingSizeLength ? parseFloat(this.shippingSizeLength) : 0,
          shippingSizeWidth: this.shippingSizeWidth ? parseFloat(this.shippingSizeWidth) : 0,
          shippingSizeHeight: this.shippingSizeHeight ? parseFloat(this.shippingSizeHeight) : 0,
          shippingSizeWeight: this.shippingSizeWeight ? parseFloat(this.shippingSizeWeight) : 0,
          condition: this.condition || null,
          hsUK: this.hsUK,
          hsEU: this.hsEU,
          hsCH: this.hsCH,
          customsTariff: this.customsTariff === "" || this.customsTariff === null || this.customsTariff === undefined ? null : parseFloat(this.customsTariff),
          outboundCarrier: carrier && carrier.name,
          carrierUK: carrierUK && carrierUK.name,
          carrierEU: carrierEU && carrierEU.name,
          bulky: this.bulky ? this.bulky : "false",
          supplierId: this.supplierId.value,
          moq: this.moq === "" || this.moq === null || this.moq === undefined ? null : parseInt(this.moq, 10),
          eol: !!this.eol,
          cabQuantity: this.cabQuantity,
          mbSkuAmount: this.mbSkuAmount,
          mbSkuHeight: this.mbSkuHeight,
          mbSkuLength: this.mbSkuLength,
          mbSkuWeight: this.mbSkuWeight,
          mbSkuWidth: this.mbSkuWidth,
          skuMasterbox: this.skuMasterbox,
          skuMetalWeight: this.skuMetalWeight,
          skuPaperWeight: this.skuPaperWeight,
          skuPlasticWeight: this.skuPlasticWeight,
          skuWoodWeight: this.skuWoodWeight,
        };
        // console.log("edit product", payload);
        axiosFactory()
          .put("shipping_data/products/" + this.id, payload)
          .then(() => {
            this.$notify({
              timeout: 2500,
              message: this.$t("products.messages.updated"),
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            this.applyFilters({});
          })
          .then(() => {
            this.hideEditModal();
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    requestFunction(data) {
      const { page, limit, orderBy, ascending, ...filters } = data;
      this.currentPage = page;
      let params = {
        pageIndex: this.currentPage,
        pageSize: limit,
        orderBy,
        ascending,
        ...filters,
      };
      if (this.filters.sku) {
        params.sku = this.filters.sku;
        params.exactMatchSku = this.filters.exactMatchSku;
      }
      this.isLoading = true;
      return axiosFactory()
        .get(`/shipping_data/products`, { params })
        .catch(function (e) {})
        .finally(() => {
          this.isLoading = false;
        });
    },
    responseFunction({ data }) {
      this.tableData = data.data.map((i) => ({ ...i, selected: false }));
      this.totalItems = data.total;

      return {
        data: this.tableData,
        count: data.total,
      };
    },
    rowClassCallback(row) {
      return "";
    },
    debounceApplyFilters: debounce(function () {
      this.applyFilters({});
    }, 300),
    applyFilters(filters) {
      this.$refs.table.options.params = {
        ...this.$refs.table.options.params,
        ...this.filters,
        ...filters,
        pageIndex: 0,
      };
      this.currentPage = 1;
      this.$refs.table.setPage(this.currentPage);
    },
    hasPermission(permissionName, tableName, columnName) {
      return hasPermission(permissionName, tableName, columnName);
    },
    exportProducts() {
      this.isLoading = true;
      axiosFactory()
        .post(`/shipping_data/export_products`)
        .then(() => {
          this.$notify({
            timeout: 2500,
            message: this.$t("products.exportSuccess"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch(() => {
          this.$notify({
            timeout: 2500,
            message: this.$t("products.exportError"),
            icon: "add_alert",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "error",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  updated() {
    EventBus.$emit("scroll:changed");
  },
  created() {
    this.$store.dispatch("shippingData/getSupplierNames");
    this.$store.dispatch("shippingData/getCarriers");
  },
};
</script>
<style scoped>
.table-transparent {
  background-color: transparent !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mr-1 {
  margin-right: 15px;
}

.md-card .md-card-header.md-card-header-icon .material-symbols-outlined {
  width: 33px;
  height: 33px;
  text-align: center;
  line-height: 33px;
  color: #fff;
  margin: 0 !important;
  font-size: 28px !important;
}
.switch-toggle-label {
  font-weight: normal !important;
}
.md-subheader {
  padding-left: 0;
}
</style>
<style>
th.shipping-stats-header {
  white-space: pre-line !important;
}
</style>
